import _ from 'lodash/fp';

const filterConfig = {
  filter(home, { values }) {
    if (!values.length) {
      return false;
    }
    return (values || [])
      .map(v => v.value)
      .includes(home.status);
  },
  collectValues(homes) {
    return _.flow(
      _.map(home => ({
        value: home.status,
      })),
      _.filter('value'),
      _.uniqBy('value'),
      _.sortBy('value'),
    )(homes);
  },
  labelRender: ({ value }) => value,
};

export default filterConfig;



// WEBPACK FOOTER //
// ./src/filters/homes/Status.js